import { useCallback } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { BACK_NAVIGATION_STATE, getNavigationOrigin } from '../../core/navigation/navigationOrigin'

/**
 * Returns a "back" handler going to the page the user actually came from, filters included, and
 * falling back to `fallbackPath` when there is no recorded origin (direct access through an URL).
 *
 * The origin is read on click, not at mount: it is recorded in an effect, and some pages rewrite
 * their own URL right after mounting.
 */
export const useGoBack = (fallbackPath: string) => {
  const navigate = useNavigate()
  const { pathname } = useLocation()

  return useCallback(() => {
    navigate(getNavigationOrigin(pathname) ?? fallbackPath, { state: BACK_NAVIGATION_STATE })
  }, [navigate, pathname, fallbackPath])
}
